import React, { useState, useEffect } from 'react';
import FormSuccessPopup from './FormSuccessPopup';
import FormLoader from './FormLoader';
const bgImage1 = require('../images/carosel_image1.webp');
const bgImage2 = require('../images/carosel_image2.webp');
const bgImage3 = require('../images/carosel_image3.webp');
const bgImage4 = require('../images/carosel_image4.webp');

const StartingPage = ({ onBookDemoClick }) => {
  const [showForm, setShowForm] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState('');
  const [selectedCourse, setSelectedCourse] = useState('');
  const [customCourse, setCustomCourse] = useState('');
  const [selectedLocation, setSelectedLocation] = useState('');
  const [showPopup, setShowPopup] = useState(false);
  const [popupType, setPopupType] = useState('success');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const carouselImages = [bgImage1, bgImage2, bgImage3, bgImage4];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prev) => (prev + 1) % carouselImages.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const courseCategories = {
    'trending-courses': {
      name: 'Trending Courses',
      courses: [
        'Artificial Intelligence & Gen-AI',
        'Prompt Engineering',
        'Cloud Computing',
        'DevOps & SRE',
        'Software Testing',
        'Data Analytics',
        'Data Engineering',
        'Full-Stack Development',
        'Power Platform / Low-Code Automation',
        'Data Science',
        'UI/UX Design'
      ]
    },
    'ai-section': {
      name: 'Artificial Intelligence',
      courses: [
        'Data Science with Gen-AI Training',
        'Generative AI Training',
        'Prompt Engineering Training',
        'Agentic AI Training',
        'Machine Learning Training',
        'Microsoft Copilot Training',
        'AI in Project Management Training',
        'AI in Excel Training',
        'AI Business Analyst Training',
        'AI Chatbot Development Training'
      ]
    },
    'software-testing': {
      name: 'Software Testing',
      courses: [
        'Selenium Automation Training (Java/Python/C#)',
        'Cypress Automation Training (JavaScript)',
        'Playwright Automation Training (TypeScript)',
        'API Testing Training (Postman + RestAssured)',
        'Performance Testing Training (JMeter)',
        'Mobile Automation Training (Appium)'
      ]
    },
    'cloud-computing': {
      name: 'Cloud Computing',
      courses: [
        'AWS Training',
        'Azure Training',
        'GCP Training',
        'Cloud Certification Training'
      ]
    },
    'devops': {
      name: 'DevOps',
      courses: [
        'DevOps Training',
        'Linux Training',
        'Git & GitHub Training',
        'CI/CD Jenkins Training',
        'Docker Training',
        'Kubernetes Training',
        'Terraform Training',
        'Ansible Training',
        'DevSecOps Training',
        'Monitoring & Observability Training'
      ]
    },
    'web-development': {
      name: 'Web Development',
      courses: [
        'React Training',
        'MERN Full-Stack Training',
        'Java Full-Stack Training',
        'Python Full-Stack Training',
        'DOT NET Full-Stack Training'
      ]
    },
    'programming': {
      name: 'Programming',
      courses: [
        'Java Programming',
        'Python Programming',
        'JavaScript Programming',
        'C Programming',
        'C++ Programming',
        'Advanced Python Training',
        'Python with Django Training',
        'Python with Flask Training'
      ]
    },
    'data-engineering': {
      name: 'Data Engineering',
      courses: [
        'Data Engineering Training',
        'Big Data Training',
        'Cloud Data Engineering Training'
      ]
    },
    'testing-addons': {
      name: 'Testing Add-ons',
      courses: [
        'ISTQB Certification Training',
        'SQL for Testers',
        'API Security Testing',
        'Automation Framework Design Training'
      ]
    },
    'power-platform': {
      name: 'Power Platform',
      courses: [
        'Power Apps Training',
        'Power Automate Training',
        'Power BI Training',
        'Microsoft Copilot Studio Training'
      ]
    },
    'data-analytics': {
      name: 'Data Analytics',
      courses: [
        'Data Analytics Training',
        'Power BI Training',
        'Tableau Training',
        'Excel Advanced Analytics Training'
      ]
    },
    'ui-ux': {
      name: 'UI/UX Design',
      courses: [
        'UI/UX Design Training',
        'Figma Training',
        'Adobe XD Training',
        'Responsive Web Design Training'
      ]
    },
    'others': {
      name: 'Others',
      courses: ['Others']
    }
  };

  const handleCategoryChange = (e) => {
    setSelectedCategory(e.target.value);
    setSelectedCourse('');
    setCustomCourse('');
  };

  return (
    <section id="home" style={{
      width: '100vw',
      height: '80vh',
      position: 'relative',
      display: 'flex',
      marginTop: '0px',
      alignItems: 'center',
      justifyContent: 'center',
      overflow: 'hidden',
      marginBottom: '-10px'
    }}>
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        background: '#000000',
        zIndex: 1
      }}></div>
      {carouselImages.map((img, index) => (
        <div key={index} style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundImage: `url(${img})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          filter: 'brightness(0.5)',
          zIndex: 2,
          opacity: currentImageIndex === index ? 1 : 0,
          transform: currentImageIndex === index ? 'scale(1.1)' : 'scale(1)',
          transition: 'opacity 1s ease-in-out, transform 5s ease-out'
        }}></div>
      ))}



      <div className="mobile-content" style={{
        position: 'absolute',
        left: '5%',
        top: '50%',
        transform: 'translateY(-50%)',
        maxWidth: '750px',
        zIndex: 3
      }}>
        <h1 style={{
          fontSize: '4.5rem',
          fontWeight: '700',
          marginBottom: '1.5rem',
          lineHeight: '1.2',
          animation: 'fadeInUp 1s ease-out',
          whiteSpace: 'nowrap'
        }}>
          <span style={{ color: '#ffffff', textShadow: '2px 2px 4px rgba(0, 0, 0, 0.8)' }}>Train. Transform.</span><br/>
          <span style={{ color: '#4a90e2', textShadow: '2px 2px 4px rgba(0, 0, 0, 0.8)' }}>Get Placed.</span>
        </h1>
        <p style={{
          color: '#ffffff',
          fontSize: '1.3rem',
          lineHeight: '1.8',
          textShadow: '2px 2px 4px rgba(0, 0, 0, 0.8)',
          opacity: 1,
          maxWidth: '750px',
          fontWeight: '500'
        }}>
         Upgrade your skills with Oraniumtech’s industry-focused IT courses and secure your dream job through our trusted placement network<br/>  
        </p>
        
        <button 
          className="mobile-register-btn"
          onClick={onBookDemoClick}
          style={{
            display: 'none',
            background: 'linear-gradient(135deg, #00315d 0%, #004080 50%, #0066cc 100%)',
            color: 'white',
            border: '2px solid rgba(255,255,255,0.2)',
            padding: '1rem 2rem',
            justifyContent: 'center',
            alignItems: 'center',
    
            borderRadius: '25px',
            cursor: 'pointer',
            fontSize: '1rem',
            fontWeight: '600',
            boxShadow: 'inset 0 2px 4px rgba(255,255,255,0.3), inset 0 -2px 4px rgba(0,0,0,0.2)',
            margin: '2rem auto 0 auto',
            textShadow: '0 1px 2px rgba(0, 0, 0, 0.3)'
          }}
        >
          Book Free Demo
        </button>
      </div>

      <div className={`starting-form ${!showForm ? 'mobile-hidden' : ''}`} style={{
        position: 'fixed',
        right: '15%',
        top: '50%',
        transform: 'translateY(-50%) perspective(1000px) rotateY(-5deg)',
        width: '400px',
        background: 'transparent',
        backdropFilter: 'blur(25px)',
        borderRadius: '25px',
        padding: '1.5rem',
        boxShadow: '0 25px 50px rgba(0, 0, 0, 0.2), inset 0 2px 4px rgba(255, 255, 255, 0.4), inset 0 -2px 4px rgba(0, 0, 0, 0.1), 0 15px 35px rgba(59, 130, 246, 0.15)',
        border: '2px solid rgba(255, 255, 255, 0.3)',
        zIndex: 3,
        animation: 'slideInRight 1s ease-out 0.5s both',
        display: showForm ? 'block' : 'block'
      }}>
        <button 
          className="close-form-btn"
          onClick={() => setShowForm(false)}
          style={{
            display: 'none',
            position: 'absolute',
            top: '10px',
            right: '10px',
            background: 'rgba(255, 255, 255, 0.2)',
            border: 'none',
            borderRadius: '50%',
            width: '30px',
            height: '30px',
            cursor: 'pointer',
            fontSize: '18px',
            color: '#ffffff',
            alignItems: 'center',
            justifyContent: 'center',
            backdropFilter: 'blur(10px)',
            transition: 'all 0.3s ease'
          }}
        >
          ×
        </button>
        <h3 style={{
          color: '#ffffff',
          fontSize: '1.8rem',
          fontWeight: '700',
          marginBottom: '1rem',
          marginTop: '2rem',
          textAlign: 'center',
          textShadow: '0 2px 4px rgba(0, 0, 0, 0.3)'
        }}>Book a Free Demo</h3>
        
        <form onSubmit={async (e) => {
          e.preventDefault();
          if (isSubmitting) return;
          
          const formData = new FormData(e.target);
          const mobileValue = formData.get('mobile');
          
          // Validate mobile number
          if (mobileValue.length !== 10) {
            alert('Please enter a valid 10-digit mobile number');
            return;
          }
          
          const submissionData = {
            fullName: formData.get('name'),
            mobile: mobileValue,
            email: formData.get('email'),
            location: selectedLocation,
            category: selectedCategory,
            course: selectedCategory === 'others' ? customCourse : selectedCourse
          };
          
          setIsSubmitting(true);
          const startTime = Date.now();
          
          try {
            const response = await fetch('/api/register.php', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(submissionData)
            });
            
            const result = await response.json();
            
            // Ensure minimum 2 seconds have passed
            const elapsed = Date.now() - startTime;
            if (elapsed < 2000) {
              await new Promise(resolve => setTimeout(resolve, 2000 - elapsed));
            }
            
            if (result.success) {
              setPopupType('success');
              e.target.reset();
              setSelectedCategory('');
              setSelectedCourse('');
              setCustomCourse('');
              setSelectedLocation('');
              setShowForm(false);
            } else {
              setPopupType('error');
            }
          } catch (error) {
            const elapsed = Date.now() - startTime;
            if (elapsed < 2000) {
              await new Promise(resolve => setTimeout(resolve, 2000 - elapsed));
            }
            setPopupType('error');
          } finally {
            setIsSubmitting(false);
            setShowPopup(true);
          }
        }} style={{ display: 'flex', flexDirection: 'column', gap: '0.6rem' }}>
          <input type="text" name="name" placeholder="Full Name" required 
            onKeyPress={(e) => {
              if (!/[a-zA-Z\s]/.test(e.key)) e.preventDefault();
            }}
            style={{
            padding: '0.4rem 0.6rem', 
            borderRadius: '12px', 
            border: '2px solid rgba(255, 255, 255, 0.4)',
            background: 'linear-gradient(145deg, rgba(255, 255, 255, 0.95) 0%, rgba(240, 248, 255, 0.9) 50%, rgba(255, 255, 255, 0.85) 100%)', 
            backdropFilter: 'blur(15px)', 
            fontSize: '0.9rem',
            color: '#1a365d', 
            outline: 'none', 
            boxShadow: 'inset 2px 2px 6px rgba(0, 0, 0, 0.1), inset -2px -2px 6px rgba(255, 255, 255, 0.8), 0 4px 12px rgba(0, 49, 93, 0.15)', 
            fontWeight: '600',
            transition: 'all 0.3s ease'
          }} />
          <input type="tel" name="mobile" placeholder="Mobile Number" required 
            onChange={(e) => {
              const value = e.target.value.replace(/\D/g, '').slice(0, 10);
              e.target.value = value;
            }}
            pattern="[0-9]{10}"
            title="Please enter exactly 10 digits"
            style={{
            padding: '0.4rem 0.6rem', 
            borderRadius: '12px', 
            border: '2px solid rgba(255, 255, 255, 0.4)',
            background: 'linear-gradient(145deg, rgba(255, 255, 255, 0.95) 0%, rgba(240, 248, 255, 0.9) 50%, rgba(255, 255, 255, 0.85) 100%)', 
            backdropFilter: 'blur(15px)', 
            fontSize: '0.9rem',
            color: '#1a365d', 
            outline: 'none', 
            boxShadow: 'inset 2px 2px 6px rgba(0, 0, 0, 0.1), inset -2px -2px 6px rgba(255, 255, 255, 0.8), 0 4px 12px rgba(0, 49, 93, 0.15)', 
            fontWeight: '600',
            transition: 'all 0.3s ease'
          }} />
          <input type="email" name="email" placeholder="Email ID" required 
            pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
            style={{
            padding: '0.4rem 0.6rem', 
            borderRadius: '12px', 
            border: '2px solid rgba(255, 255, 255, 0.4)',
            background: 'linear-gradient(145deg, rgba(255, 255, 255, 0.95) 0%, rgba(240, 248, 255, 0.9) 50%, rgba(255, 255, 255, 0.85) 100%)', 
            backdropFilter: 'blur(15px)', 
            fontSize: '0.9rem',
            color: '#1a365d', 
            outline: 'none', 
            boxShadow: 'inset 2px 2px 6px rgba(0, 0, 0, 0.1), inset -2px -2px 6px rgba(255, 255, 255, 0.8), 0 4px 12px rgba(0, 49, 93, 0.15)', 
            fontWeight: '600',
            transition: 'all 0.3s ease'
          }} />
          <select 
            value={selectedLocation}
            onChange={(e) => setSelectedLocation(e.target.value)}
            className="custom-select"
            required
            style={{
              padding: '0.4rem 0.6rem', 
              borderRadius: '12px', 
              border: '2px solid rgba(255, 255, 255, 0.4)',
              background: 'linear-gradient(145deg, rgba(255, 255, 255, 0.95) 0%, rgba(240, 248, 255, 0.9) 50%, rgba(255, 255, 255, 0.85) 100%)', 
              backdropFilter: 'blur(15px)', 
              fontSize: '0.9rem',
              color: '#1a365d', 
              outline: 'none', 
              boxShadow: 'inset 2px 2px 6px rgba(0, 0, 0, 0.1), inset -2px -2px 6px rgba(255, 255, 255, 0.8), 0 4px 12px rgba(0, 49, 93, 0.15)', 
              fontWeight: '600', 
              transition: 'all 0.3s ease',
              cursor: 'pointer'
            }}>
            <option value="">Preferred Location</option>
            <option value="Chrompet">Chrompet</option>
            <option value="Velachery">Velachery</option>
            <option value="Online">Online</option>
          </select>
          <select 
            value={selectedCategory}
            onChange={handleCategoryChange}
            className="custom-select"
            style={{
              padding: '0.4rem 0.6rem', 
              borderRadius: '12px', 
              border: '2px solid rgba(255, 255, 255, 0.4)',
              background: 'linear-gradient(145deg, rgba(255, 255, 255, 0.95) 0%, rgba(240, 248, 255, 0.9) 50%, rgba(255, 255, 255, 0.85) 100%)', 
              backdropFilter: 'blur(15px)', 
              fontSize: '0.9rem',
              color: '#1a365d', 
              outline: 'none', 
              boxShadow: 'inset 2px 2px 6px rgba(0, 0, 0, 0.1), inset -2px -2px 6px rgba(255, 255, 255, 0.8), 0 4px 12px rgba(0, 49, 93, 0.15)', 
              fontWeight: '600', 
              transition: 'all 0.3s ease',
              cursor: 'pointer'
            }}>
            <option value="">Select Course Category</option>
            {Object.entries(courseCategories).map(([key, category]) => (
              <option key={key} value={key}>{category.name}</option>
            ))}
          </select>
          {selectedCategory === 'others' ? (
            <input 
              type="text" 
              placeholder="Please specify your course" 
              value={customCourse} 
              onChange={(e) => setCustomCourse(e.target.value)} 
              required
              style={{
                padding: '0.4rem 0.6rem', 
                borderRadius: '12px', 
                border: '2px solid rgba(255, 255, 255, 0.4)',
                background: 'linear-gradient(145deg, rgba(255, 255, 255, 0.95) 0%, rgba(240, 248, 255, 0.9) 50%, rgba(255, 255, 255, 0.85) 100%)', 
                backdropFilter: 'blur(15px)', 
                fontSize: '0.9rem',
                color: '#1a365d', 
                outline: 'none', 
                boxShadow: 'inset 2px 2px 6px rgba(0, 0, 0, 0.1), inset -2px -2px 6px rgba(255, 255, 255, 0.8), 0 4px 12px rgba(0, 49, 93, 0.15)', 
                fontWeight: '600',
                transition: 'all 0.3s ease'
              }} 
            />
          ) : (
            <select 
              value={selectedCourse}
              onChange={(e) => {
                setSelectedCourse(e.target.value);
                setCustomCourse('');
              }}
              disabled={!selectedCategory}
              className="custom-select"
              required
              style={{
                padding: '0.4rem 0.6rem', 
                borderRadius: '12px', 
                border: '2px solid rgba(255, 255, 255, 0.4)',
                background: selectedCategory 
                  ? 'linear-gradient(145deg, rgba(255, 255, 255, 0.95) 0%, rgba(240, 248, 255, 0.9) 50%, rgba(255, 255, 255, 0.85) 100%)' 
                  : 'linear-gradient(145deg, rgba(200, 200, 200, 0.7) 0%, rgba(220, 220, 220, 0.6) 50%, rgba(200, 200, 200, 0.5) 100%)', 
                backdropFilter: 'blur(15px)', 
                fontSize: '0.9rem',
                color: selectedCategory ? '#1a365d' : '#64748b', 
                outline: 'none', 
                boxShadow: selectedCategory 
                  ? 'inset 2px 2px 6px rgba(0, 0, 0, 0.1), inset -2px -2px 6px rgba(255, 255, 255, 0.8), 0 4px 12px rgba(0, 49, 93, 0.15)' 
                  : 'inset 1px 1px 3px rgba(0, 0, 0, 0.05), inset -1px -1px 3px rgba(255, 255, 255, 0.4)', 
                fontWeight: '600', 
                transition: 'all 0.3s ease',
                cursor: selectedCategory ? 'pointer' : 'not-allowed',
                opacity: selectedCategory ? 1 : 0.7
              }}>
              <option value="">Select Specific Course</option>
              {selectedCategory && courseCategories[selectedCategory].courses.map((course, index) => (
                <option key={index} value={course}>{course}</option>
              ))}
            </select>
          )}

          <button type="submit" disabled={isSubmitting} style={{
            background: 'linear-gradient(135deg, #00315d 0%, #004080 50%, #0066cc 100%)',
            color: 'white', 
            border: '2px solid rgba(255,255,255,0.2)', 
            padding: '0.7rem 1.5rem',
            borderRadius: '20px', 
            cursor: isSubmitting ? 'not-allowed' : 'pointer', 
            fontSize: '0.9rem', 
            fontWeight: '600',
            boxShadow: 'inset 0 2px 4px rgba(255,255,255,0.3), inset 0 -2px 4px rgba(0,0,0,0.2)',
            marginTop: '0.5rem', 
            textShadow: '0 1px 2px rgba(0, 0, 0, 0.3)',
            opacity: isSubmitting ? 0.7 : 1
          }}>{isSubmitting ? 'Submitting...' : 'Submit'}</button>
        </form>
      </div>

      <FormSuccessPopup 
        isOpen={showPopup}
        onClose={() => setShowPopup(false)}
        type={popupType}
      />

      <style>
        {`
          .custom-select option {
            background: linear-gradient(145deg, rgba(255, 255, 255, 0.98) 0%, rgba(240, 248, 255, 0.95) 50%, rgba(255, 255, 255, 0.92) 100%) !important;
            color: #1a365d !important;
            padding: 0.6rem 1rem !important;
            font-weight: 600 !important;
            border: none !important;
            margin: 2px 0 !important;
            border-radius: 8px !important;
          }
          .custom-select option:hover {
            background: linear-gradient(145deg, rgba(59, 130, 246, 0.9) 0%, rgba(37, 99, 235, 0.85) 50%, rgba(29, 78, 216, 0.8) 100%) !important;
            color: white !important;
            box-shadow: inset 1px 1px 3px rgba(255, 255, 255, 0.3), inset -1px -1px 3px rgba(0, 0, 0, 0.2) !important;
          }
          .custom-select option:checked, .custom-select option:selected {
            background: linear-gradient(145deg, #00315d 0%, #004080 50%, #0066cc 100%) !important;
            color: white !important;
            font-weight: 700 !important;
          }
          @keyframes fadeInUp {
            0% {
              opacity: 0;
              transform: translateY(30px);
            }
            100% {
              opacity: 1;
              transform: translateY(0);
            }
          }
          @keyframes slideInRight {
            0% {
              opacity: 0;
              transform: translateY(-50%) translateX(50px);
            }
            100% {
              opacity: 1;
              transform: translateY(-50%) translateX(0);
            }
          }
          @keyframes blink {
            0%, 50% { opacity: 1; }
            25%, 75% { opacity: 0.3; }
          }
          @media (min-width: 1025px) and (max-width: 1440px) {
            .mobile-content {
              max-width: 550px !important;
            }
            .mobile-content h1 {
              font-size: 3.5rem !important;
            }
            .mobile-content p {
              font-size: 1.15rem !important;
            }
            .starting-form {
              right: 5% !important;
              width: 340px !important;
              padding: 1rem !important;
            }
            .starting-form h3 {
              font-size: 1.4rem !important;
              margin-bottom: 0.6rem !important;
              margin-top: 1rem !important;
            }
            .starting-form form {
              gap: 0.4rem !important;
            }
            .starting-form input,
            .starting-form select {
              padding: 0.3rem 0.5rem !important;
              font-size: 0.8rem !important;
            }
            .starting-form button {
              padding: 0.5rem 1rem !important;
              font-size: 0.8rem !important;
              margin-top: 0.3rem !important;
            }
          }
          @media (max-width: 1024px) {
            #home {
              padding: 3rem 2rem !important;
            }
            .mobile-content {
              max-width: 500px !important;
            }
            .mobile-content h1 {
              font-size: 3rem !important;
            }
            .mobile-content p {
              font-size: 1.1rem !important;
            }
            .starting-form {
              right: 5% !important;
              width: 350px !important;
              padding: 1.2rem !important;
            }
            .starting-form h3 {
              font-size: 1.5rem !important;
            }
            .starting-form input,
            .starting-form select {
              padding: 0.35rem 0.5rem !important;
              font-size: 0.85rem !important;
            }
            .starting-form button {
              padding: 0.6rem 1.2rem !important;
              font-size: 0.85rem !important;
            }
          }
          @media (max-width: 768px) {
            #home {
              height: auto !important;
              min-height: 70vh !important;
              flex-direction: column !important;
              padding: 2rem 1rem 3rem !important;
              width: 100% !important;
              margin-bottom: 0 !important;
            }
          @media (max-width: 480px) {
            .mobile-content h1 {
              font-size: 2rem !important;
            }
            .mobile-content p {
              font-size: 1rem !important;
            }
            .starting-form {
              padding: 1.2rem !important;
            }
          }
            .mobile-content {
              position: relative !important;
              left: auto !important;
              top: auto !important;
              transform: translateY(-5vh) !important;
              max-width: 100% !important;
              width: 100% !important;
              margin-bottom: 2rem !important;
              padding: 0 1rem !important;
              box-sizing: border-box !important;
            }
            .mobile-content h1 {
              font-size: 2.5rem !important;
              white-space: normal !important;
              text-align: center !important;
            }
            .mobile-content p {
              font-size: 1.1rem !important;
              max-width: 100% !important;
              text-align: left !important;
            }
            .mobile-register-btn {
              display: block !important;
            }
            .starting-form {
              position: relative !important;
              right: auto !important;
              top: auto !important;
              transform: none !important;
              width: calc(100% - 2rem) !important;
              max-width: 400px !important;
              margin: 2rem auto 0 !important;
              padding: 1.5rem !important;
              box-sizing: border-box !important;
            }
            .starting-form.mobile-hidden {
              display: none !important;
            }
            .close-form-btn {
              display: flex !important;
            }
            .close-form-btn:hover {
              background: rgba(255, 255, 255, 0.3) !important;
              transform: scale(1.1) !important;
            }
            .close-form-btn:focus {
              outline: none !important;
            }
            .starting-form h3 {
              font-size: 1.5rem !important;
            }
            .starting-form input, .starting-form select {
              font-size: 0.9rem !important;
              padding: 0.7rem 0.8rem !important;
            }
            .starting-form button {
              padding: 0.8rem 1.5rem !important;
              font-size: 0.9rem !important;
            }
          }
        `}
      </style>
      <FormLoader isLoading={isSubmitting} />
    </section>
  );
};

export default StartingPage;